import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { SessionProvider } from './session/SessionProvider'

// Стили НЕ импортируются здесь: дизайн — точная копия legacy, CSS подключён
// в index.html из /assets/css (bootstrap.min.css, main.css, all.css) — CLAUDE.md п.9.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
)
